// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/raleway-font/raleway-bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/raleway-font/raleway-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/raleway-font/raleway-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/raleway-font/raleway-bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/raleway-font/raleway-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/raleway-font/raleway-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../fonts/raleway-font/raleway-light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../fonts/raleway-font/raleway-light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../fonts/raleway-font/raleway-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../fonts/raleway-font/raleway-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../fonts/raleway-font/raleway-medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../fonts/raleway-font/raleway-medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../fonts/raleway-font/raleway-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../fonts/raleway-font/raleway-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../fonts/raleway-font/raleway-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../fonts/raleway-font/raleway-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../fonts/raleway-font/raleway-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../fonts/raleway-font/raleway-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../fonts/raleway-font/raleway-semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../fonts/raleway-font/raleway-semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* FONTS */
/* COLORS */
:root {
    --color-main: #242857;
    --color-white: #fff;
    --color-granite: #353642;
    --color-blackberry: #6F707A;
    --color-yellow-pink: #F08572;
    --color-pale-blue: #D7D8E0;
    --color-light-periwinkle-crayola: #ebecf2;
    --color-error: #E73E52;
    --color-blue-alice: #E9F2FF;
    --color-periwinkle-crayola: #f5f5fa;
    --color-burgundy-purple: #752441;
    --color-gray-window: #A0A1AD;
    --color-blue-steel: #4777BB;
    --color-smoky-white: #F7F7F7;
    --color-gray-blue: #292B33;
    --color-mint: #3AB17F;

    --font-m: 1rem;
    --font-s: 0.875rem;
    --font-xs: 0.75rem;
    --font-l: 1.5rem;
    --font-xl: 2rem;

    --block-margin-y: 100px;
}

@media screen and (max-width: 1024px) {
    :root {
        --font-m: 1rem;
        --font-s: 0.875rem;
        --font-xs: 0.75rem;
        --font-l: 1.25rem;
        --font-xl: 1.5rem;
        --block-margin-y: 50px;
    }
}

.block-margin-y {
    margin-top: var(--block-margin-y);
    margin-bottom: var(--block-margin-y);
}

/* FONTS */
@font-face {
    font-family: 'RalewayBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("eot"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("svg");
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'RalewayLight';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("eot"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("svg");
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'RalewayMedium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("eot"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'RalewayRegular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("eot"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'RalewaySemiBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("eot"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("svg");
    font-weight: normal;
    font-style: normal;
}

*,
*:before,
*:after {
    box-sizing: border-box;
}

html,
body {
    padding: 0;
    margin: 0;
    font-size: 16px;
}

@media screen and (max-width: 1024px) {
    html {
        font-size: 14px;
    }
}

html {
    background-color: #ffffff;
}

body {
    font-family: "RalewayRegular", serif;
    -webkit-font-feature-settings: "lnum";
    font-feature-settings: "lnum";
    overflow-x: hidden;
    max-width: min(100%, 1920px);
    margin: 0 auto;
}

body._over {
    overflow: hidden;
}

address {
    font-style: normal;
}

button {
    cursor: pointer;
}

a {
    text-decoration: none;
    outline: none !important;
}

ul {
    padding-left: 0;
}

li {
    list-style-type: none;
}

img {
    height: auto;
    max-width: 100%;
    pointer-events: none;
}

label {
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

textarea {
    resize: vertical;
}

input[placeholder] {
    text-overflow: ellipsis;
    white-space: nowrap;
}

:focus::-webkit-input-placeholder {
    color: transparent;
}

:focus::-moz-placeholder {
    color: transparent;
}

:focus:-moz-placeholder {
    color: transparent;
}

:focus:-ms-input-placeholder {
    color: transparent;
}

input[type="number"] {
    -moz-appearance: textfield;
}

input[type="number"]:hover,
input[type="number"]:focus {
    -moz-appearance: number-input;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* rybl */
/*
.rubl {
    font-family: 'Rubik', serif;
}
*/

.btn {
    background: var(--color-main);
    border-radius: 4px;
    color: var(--color-white);
    font-family: "RalewaySemiBold";
}

.button {
    background: var(--color-main);
    border-radius: 6px;
    color: var(--color-white);
    font-family: "RalewaySemiBold";
    cursor: pointer;
    text-decoration: none !important;
    outline: none !important;
    display: inline-block;
}

.button_s {
    font-size: var(--font-s);
    padding: 5px 15px;
}

.button_m {
    font-size: var(--font-m);
    padding: 7px 20px;
}

.button_l {
    font-size: var(--font-l);
    padding: 10px 30px;
}

/* ERROR FORM */
._error .error-text {
    display: block;
}

.error-text {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-error);
    margin-top: 8px;
}

[v-cloak] {
    display: none;
}

.container {
    display: block;
    margin: 0 auto;
    padding: 0 24px;
}

.container_center {
    max-width: 1200px;
}

@media screen and (max-width: 1024px) {
    .container {
        padding: 0 20px;
    }

    /*.index-stocks .container,*/
    /*.index-banner .container{*/
    /*    padding:0;*/
    /*}*/
}

@media screen and (max-width: 500px) {
    .container {
        overflow-x: hidden;
    }
}

.input {
    height: 40px;
    width: 100%;
    display: block;
    background: var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    border: 2px solid var(--color-light-periwinkle-crayola);
    outline: none !important;
}

.input:focus {
    border: 2px solid var(--color-blue-steel);
    outline: none !important;
}

.input::placeholder {
}

.input_inverse {
    background: var(--color-white);
}

.font-xs {
    font-size: var(--font-xs);
}

.font-s {
    font-size: var(--font-s);
}

.font-m {
    font-size: var(--font-m);
}

.font-l {
    font-size: var(--font-l);
}

.font-xl {
    font-size: var(--font-xl);
}

.font-bold {
    font-weight: 700;
}

.font-lite {
    font-weight: 100;
}

.font-normal {
    font-weight: normal;
}


`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/settings.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,UAAU;AACV,WAAW;AACX;IACI,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;IAC1B,yCAAyC;IACzC,sBAAsB;IACtB,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;IAC1B,qBAAqB;;IAErB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;;IAEf,uBAAuB;AAC3B;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QACjB,iBAAiB;QACjB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA,UAAU;AACV;IACI,0BAA0B;IAC1B;;;yDAG8D;IAC9D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B;;;yDAG+D;IAC/D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B;;;0DAGgE;IAChE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B;;;0DAGiE;IACjE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B;;;0DAGkE;IAClE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,SAAS;AACT;;;;CAIC;;AAED;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA,4BAA4B;IAC5B,4BAA4B;IAC5B,iBAAiB;IACjB,IAAI;AACR;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,iDAAiD;IACjD,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,uDAAuD;IACvD,wBAAwB;AAC5B;;AAEA;IACI,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;AACA;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["@charset \"UTF-8\";\n/* FONTS */\n/* COLORS */\n:root {\n    --color-main: #242857;\n    --color-white: #fff;\n    --color-granite: #353642;\n    --color-blackberry: #6F707A;\n    --color-yellow-pink: #F08572;\n    --color-pale-blue: #D7D8E0;\n    --color-light-periwinkle-crayola: #ebecf2;\n    --color-error: #E73E52;\n    --color-blue-alice: #E9F2FF;\n    --color-periwinkle-crayola: #f5f5fa;\n    --color-burgundy-purple: #752441;\n    --color-gray-window: #A0A1AD;\n    --color-blue-steel: #4777BB;\n    --color-smoky-white: #F7F7F7;\n    --color-gray-blue: #292B33;\n    --color-mint: #3AB17F;\n\n    --font-m: 1rem;\n    --font-s: 0.875rem;\n    --font-xs: 0.75rem;\n    --font-l: 1.5rem;\n    --font-xl: 2rem;\n\n    --block-margin-y: 100px;\n}\n\n@media screen and (max-width: 1024px) {\n    :root {\n        --font-m: 1rem;\n        --font-s: 0.875rem;\n        --font-xs: 0.75rem;\n        --font-l: 1.25rem;\n        --font-xl: 1.5rem;\n        --block-margin-y: 50px;\n    }\n}\n\n.block-margin-y {\n    margin-top: var(--block-margin-y);\n    margin-bottom: var(--block-margin-y);\n}\n\n/* FONTS */\n@font-face {\n    font-family: 'RalewayBold';\n    src: url(\"../../fonts/raleway-font/raleway-bold.eot\") format(\"eot\"),\n    url(\"../../fonts/raleway-font/raleway-bold.woff\") format(\"woff\"),\n    url(\"../../fonts/raleway-font/raleway-bold.ttf\") format(\"truetype\"),\n    url(\"../../fonts/raleway-font/raleway-bold.svg\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RalewayLight';\n    src: url(\"../../fonts/raleway-font/raleway-light.eot\") format(\"eot\"),\n    url(\"../../fonts/raleway-font/raleway-light.woff\") format(\"woff\"),\n    url(\"../../fonts/raleway-font/raleway-light.ttf\") format(\"truetype\"),\n    url(\"../../fonts/raleway-font/raleway-light.svg\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RalewayMedium';\n    src: url(\"../../fonts/raleway-font/raleway-medium.eot\") format(\"eot\"),\n    url(\"../../fonts/raleway-font/raleway-medium.woff\") format(\"woff\"),\n    url(\"../../fonts/raleway-font/raleway-medium.ttf\") format(\"truetype\"),\n    url(\"../../fonts/raleway-font/raleway-medium.svg\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RalewayRegular';\n    src: url(\"../../fonts/raleway-font/raleway-regular.eot\") format(\"eot\"),\n    url(\"../../fonts/raleway-font/raleway-regular.woff\") format(\"woff\"),\n    url(\"../../fonts/raleway-font/raleway-regular.ttf\") format(\"truetype\"),\n    url(\"../../fonts/raleway-font/raleway-regular.svg\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RalewaySemiBold';\n    src: url(\"../../fonts/raleway-font/raleway-semibold.eot\") format(\"eot\"),\n    url(\"../../fonts/raleway-font/raleway-semibold.woff\") format(\"woff\"),\n    url(\"../../fonts/raleway-font/raleway-semibold.ttf\") format(\"truetype\"),\n    url(\"../../fonts/raleway-font/raleway-semibold.svg\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n}\n\n*,\n*:before,\n*:after {\n    box-sizing: border-box;\n}\n\nhtml,\nbody {\n    padding: 0;\n    margin: 0;\n    font-size: 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    html {\n        font-size: 14px;\n    }\n}\n\nhtml {\n    background-color: #ffffff;\n}\n\nbody {\n    font-family: \"RalewayRegular\", serif;\n    -webkit-font-feature-settings: \"lnum\";\n    font-feature-settings: \"lnum\";\n    overflow-x: hidden;\n    max-width: min(100%, 1920px);\n    margin: 0 auto;\n}\n\nbody._over {\n    overflow: hidden;\n}\n\naddress {\n    font-style: normal;\n}\n\nbutton {\n    cursor: pointer;\n}\n\na {\n    text-decoration: none;\n    outline: none !important;\n}\n\nul {\n    padding-left: 0;\n}\n\nli {\n    list-style-type: none;\n}\n\nimg {\n    height: auto;\n    max-width: 100%;\n    pointer-events: none;\n}\n\nlabel {\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\ntextarea {\n    resize: vertical;\n}\n\ninput[placeholder] {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n:focus::-webkit-input-placeholder {\n    color: transparent;\n}\n\n:focus::-moz-placeholder {\n    color: transparent;\n}\n\n:focus:-moz-placeholder {\n    color: transparent;\n}\n\n:focus:-ms-input-placeholder {\n    color: transparent;\n}\n\ninput[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\ninput[type=\"number\"]:hover,\ninput[type=\"number\"]:focus {\n    -moz-appearance: number-input;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* rybl */\n/*\n.rubl {\n    font-family: 'Rubik', serif;\n}\n*/\n\n.btn {\n    background: var(--color-main);\n    border-radius: 4px;\n    color: var(--color-white);\n    font-family: \"RalewaySemiBold\";\n}\n\n.button {\n    background: var(--color-main);\n    border-radius: 6px;\n    color: var(--color-white);\n    font-family: \"RalewaySemiBold\";\n    cursor: pointer;\n    text-decoration: none !important;\n    outline: none !important;\n    display: inline-block;\n}\n\n.button_s {\n    font-size: var(--font-s);\n    padding: 5px 15px;\n}\n\n.button_m {\n    font-size: var(--font-m);\n    padding: 7px 20px;\n}\n\n.button_l {\n    font-size: var(--font-l);\n    padding: 10px 30px;\n}\n\n/* ERROR FORM */\n._error .error-text {\n    display: block;\n}\n\n.error-text {\n    font-size: 14px;\n    line-height: 18px;\n    color: var(--color-error);\n    margin-top: 8px;\n}\n\n[v-cloak] {\n    display: none;\n}\n\n.container {\n    display: block;\n    margin: 0 auto;\n    padding: 0 24px;\n}\n\n.container_center {\n    max-width: 1200px;\n}\n\n@media screen and (max-width: 1024px) {\n    .container {\n        padding: 0 20px;\n    }\n\n    /*.index-stocks .container,*/\n    /*.index-banner .container{*/\n    /*    padding:0;*/\n    /*}*/\n}\n\n@media screen and (max-width: 500px) {\n    .container {\n        overflow-x: hidden;\n    }\n}\n\n.input {\n    height: 40px;\n    width: 100%;\n    display: block;\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    border: 2px solid var(--color-light-periwinkle-crayola);\n    outline: none !important;\n}\n\n.input:focus {\n    border: 2px solid var(--color-blue-steel);\n    outline: none !important;\n}\n\n.input::placeholder {\n}\n\n.input_inverse {\n    background: var(--color-white);\n}\n\n.font-xs {\n    font-size: var(--font-xs);\n}\n\n.font-s {\n    font-size: var(--font-s);\n}\n\n.font-m {\n    font-size: var(--font-m);\n}\n\n.font-l {\n    font-size: var(--font-l);\n}\n\n.font-xl {\n    font-size: var(--font-xl);\n}\n\n.font-bold {\n    font-weight: 700;\n}\n\n.font-lite {\n    font-weight: 100;\n}\n\n.font-normal {\n    font-weight: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
